import { inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivateFn,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { AuthService } from './auth.service';

export const canActivateTeam: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (route.data['externalUrl']) {
    window.location.href = route.data['externalUrl'];
    return false;
  }

  if (authService.hasValidToken()) {
    return true;
  } else {
    router.navigate(['/ignite/sign-in']);
    return false;
  }
};

export function authAppInitializerFactory(
  authService: AuthService
): () => Promise<boolean> {
  return () => authService.runInitialLoginSequence();
}
